import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { TicketListPage } from '../Tickets'
import {DataGrid} from "../../components";



export const CustomerDataGrid = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  loading
}):React.FC => {
  const actionFormatter = (cell, row) => {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <ReactBootstrap.Dropdown size="sm" variant="success">
          <ReactBootstrap.Dropdown.Toggle
            variant="dark"
            size="sm"
          ></ReactBootstrap.Dropdown.Toggle>
          <ReactBootstrap.Dropdown.Menu>
            <components.Slider
                sliderWidth={"50vw"}
              title={<span>{components.ICONS.VIEW}Tickets</span>}
              header={
                <span>
                  {components.ICONS.VIEW}Tickets for{' '}
                  <span className="pl-2">{row.contact_number}</span>{' '}
                </span>
              }
              buttonType="dropdown"
            >
              <TicketListPage defaultFilters={{ customer: row.contact_number }}/>
            </components.Slider>
          </ReactBootstrap.Dropdown.Menu>
        </ReactBootstrap.Dropdown>
      </div>
    )
  }
  const columns = [
    {
      dataField: 'first_name',
      text: 'First Name',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text'
    },
    {
      dataField: 'last_name',
      text: 'Last Name',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'email',
      text: 'User Email',
      type: 'string',
      hidden: true,
      searchFieldType: 'email',
    },
    {
      dataField: 'contact_number',
      text: 'Contact Number',
      type: 'string',
      searchFieldType: 'text',
    },
    {
      dataField: 'customer_type',
      text: 'Type',
      type: 'string',
      searchFieldType: 'text',
    },

    {
      dataField: 'city',
      text: 'City',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'state',
      text: 'State',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },

    {
      dataField: '',
      text: '',

      formatter: actionFormatter,
    },
  ]

  return (
 <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Customers</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              size="sm"
                sliderWidth={"20vw"}
              title={components.ICONS.SEARCH}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Customers</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>

          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <DataGrid
          data={results || []}
          sizePerPage={page_size || 10}
          page={current || 1}
          columns={columns}
          count={count || 0}
          onTableChange={handleTableChange}
          loading={loading}
          caption={"customers"}

        />
 </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
